export const AUC_ENVIRONMENT = {
  authConfig: {
    clientId: "ff03286c-0ac8-4b18-bb10-98e9f780055e",
    issuer: "https://login.incora.com/tfp/a42f291c-cd14-4967-9b76-39b8737608f1/B2C_1A_SIGNUP_SIGNIN_OAUTH_30M/v2.0/",
    scope: "openid profile email offline_access https://login.incora.com/f5c73591-4844-4350-93f0-2749ece220fb/read"
  },
  authenticatedUrls: [
    "https://shop.incora.com",
    "https://app.hw2.shop.incora.com",
    "https://auction.incora.com/api/Auction"
  ],
  authenticatedUrlsExclude: [],
  portalsCarriersUrl: "carriers",
  portalsNewUrl: "new",
  portalsExistingUrl: "existing",
  portalsCartsUrl: "carts",
  portalsCustomerRootUrl: "https://app.hw2.shop.incora.com/api/Customer",
  portalsCustomerManagementRootUrl: "https://shop.incora.com/api/Onboarding",
  portalsCustomersUrl: "customers",
  portalsCustomerUrl: "customer",
  portalsDocumentsUrl: "documents",
  portalsInvoicesUrl: "invoices",
  portalsLinesUrl: "lines",
  portalsManufacturersUrl: "manufacturers",
  portalsOrdersUrl: "orders",
  portalsPaymentsUrl: "payments",
  portalsRequestForQuoteUrl: "rfq",
  portalsStocksUrl: "stocks",
  portalsUserRootUrl: "https://shop.incora.com/api/Users",
  productImageUrl: "https://assets1.incora.com/product/images?itemCode=",
  production: true,
  googleAnalyticsTrackingCode: "G-YMY5GBS3Q4",
  envName: "PRODUCTION",
  auctionManagementRootUrl: "https://auction.incora.com/api/Auction",
  auctionManagementUpdateHubUrl: "auctionHub",
  auctionManagementAuctionsUrl: "auctions",
  auctionManagementImagesUrl: "images",
  auctionManagementStocksUrl: "stocks",
  auctionManagementBidsUrl: "bids",
  auctionManagementAllUrl: "all",
  eCommerceUrl: "https://shop.incora.com",
};